import {http} from '@/http'

export default {
  listAll() {
    return http.get('/api/v1/categories')
  },
  list(data, params) {
    return http.post('/api/v1/categories/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/categories', data)
  },
  get(id) {
    return http.get(`/api/v1/categories/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/categories/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/categories/${id}/status`, null, {
      params: { status },
    });
  }
}
